import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
    selector: 'app-formly-wrapper-connect-section',
    imports: [
        CommonModule,
        ReactiveFormsModule
    ],
    template: `
    <div [class]="props['htmlClass'] || ''">
        <div *ngIf="props['title']" class="row section__heading">
            <div class="col-sm-12">
                <h3 *ngIf="sectionTitle"
                    class="legend"
                    [class]="props['labelHtmlClass'] || ''"
                    [innerHTML]="sectionTitle"
                    >
                </h3>
                <p *ngIf="props['subtitle']">{{props['subtitle']}}</p>
            </div>
        </div>
        <ng-container #fieldComponent></ng-container>
    </div>
  `
})
export class ConnectSectionWrapperComponent extends FieldWrapper {
    get sectionTitle() {
        return this.props[ 'title' ];
    }
}
